/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { checkIsActive } from "../../../../_helpers";
import {
  faUsers,
  faClipboardCheck,
  faPoll,
} from "@fortawesome/free-solid-svg-icons";

import { authSlice } from "../../../../../Store/modules/AuthModule/authSlice";
import { routers } from "../../../../../Constants/router_paths";

const { actions } = authSlice;

export function AsideMenuList({ layoutProps }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/">
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                home
              </span>
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/applications", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/applications">
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                emoji_events
              </span>
            </span>
            <span className="menu-text">Applications List</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive(
            "/employer-profile",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/employer-profile">
            <span className="menu-icon">
              <span className="material-icons">perm_identity</span>
            </span>
            <span className="menu-text">Employer Profile</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* Bootstrap */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/events", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/events">
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                today
              </span>
            </span>
            <span className="menu-text">View Events</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/messages", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/messages">
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                chat
              </span>
            </span>
            <span className="menu-text">View Messages</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/account", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/account">
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                account_circle
              </span>
            </span>
            <span className="menu-text">My Account</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive(
            routers.coaches_clients,
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to={routers.coaches_clients}>
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                people
              </span>
            </span>
            <span className="menu-text">Coaches & Clients</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive(
            routers.organizations,
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to={routers.organizations}>
            <span className="menu-icon">
              <span class="material-icons material-icons-outlined">
                business
              </span>
            </span>
            <span className="menu-text">Organizations</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(routers.requests, false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to={routers.requests}>
            <span className="menu-icon">
              <span class="material-icons material-symbols-outlined">request_page</span>
            </span>
            <span className="menu-text">Requests</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(routers.feeds, false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to={routers.feeds}>
            <span className="menu-icon">
              <span class="material-icons material-symbols-outlined">
                dynamic_feed
              </span>
            </span>
            <span className="menu-text">Posts</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(routers.EnterpriseRequest, false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to={routers.EnterpriseRequest}>
            <span className="menu-icon">
              <span class="material-icons material-symbols-outlined">assignment</span>
            </span>
            <span className="menu-text">Enterprise Requests</span>
          </NavLink>
        </li>
        {/* <li
          className={`mt-10 menu-item ${getMenuItemActive("/#", false)}`}
          aria-haspopup="true"
        >
          <div
            className="menu-link"
            onClick={() => {
              dispatch(actions.logout());
            }}
          >
            <span className="menu-icon">
              <span
                className="material-icons material-icons-outlined"
                style={{ transform: "scale(1, -1)" }}
              >
                exit_to_app
              </span>
            </span>
            <span className="menu-text">Logout</span>
          </div>
        </li>
        */}
        {/*end::1 Level*/}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
